module.exports = __webpack_public_path__ + "img/timesheets-menuicon.656c4003.svg";